import { render, staticRenderFns } from "./ProducerWebhooks.vue?vue&type=template&id=4c76e218&"
import script from "./ProducerWebhooks.vue?vue&type=script&lang=js&"
export * from "./ProducerWebhooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports